import Service from '@ember/service';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from './session-context';
import type AnswerProfileModel from 'tio-data/models/answer-profile';

export default class AnswerProfileService extends Service {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  storeAnswers = async (providingApp = 'DASHBOARD', answers = {}) => {
    let profile = this.sessionContext.user.answerProfile;

    if (!profile) {
      // @ts-expect-error not sure
      profile = await this.findOrCreateAnswerProfileForCurrentUser();
    }

    if (!profile) {
      throw new Error('Could not find or create answer profile');
    }

    profile.providingApp = providingApp;
    for (const key in answers) {
      // @ts-expect-error: Find out possible values.
      profile[key] = answers[key];
    }
    await profile.save();
    return profile;
  };

  findOrCreateAnswerProfileForCurrentUser = async () => {
    if (this.sessionContext.user.answerProfile) {
      return this.sessionContext.user.answerProfile;
    }

    const queryResults = await this.store.query<AnswerProfileModel>('answer-profile', {
      filter: {
        user: this.sessionContext.user.id,
      },
      include: 'user',
    });

    if (queryResults.length) {
      return queryResults[0];
    } else {
      const answerProfile = this.store.createRecord<AnswerProfileModel>('answer-profile', {
        // TODO:
        // Remove non-null constaint from tio-api / database.
        // The database requires a value for `providing_app` and it must be an enum value
        // and therefore we have to have some default here to avoid errors on save if no
        // additional value is provided. - Julia 03/06/2023
        providingApp: 'DASHBOARD',
        user: this.sessionContext.user,
      });
      return answerProfile;
    }
  };
}
